import { CloudUpload } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useRef } from "react";
import { Button as AquiloButton } from "@truevault/aquilo";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";

export const FileUploadButton: React.FC<{
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled: boolean;
  useAquiloDesign?: boolean;
}> = ({ onChange, disabled = false, useAquiloDesign = false }) => {
  const uploadEl = useRef<HTMLInputElement>();

  return (
    <>
      <input
        style={{ display: "none" }}
        ref={uploadEl}
        id="note-upload"
        type="file"
        multiple={false}
        onChange={onChange}
      />

      {useAquiloDesign ? (
        <div className="tw-boundary">
          <AquiloButton
            color="tertiary"
            customSizeClassname="h-[30px] w-auto"
            onClick={() => uploadEl.current?.click()}
            disabled={disabled}
          >
            <div className="flex items-center">
              <div>
                <CloudArrowUpIcon className="h-[16px] w-[16px] text-neutral-600" />
              </div>
              <div className="ml-[8px] text-[12px] text-neutral-800 font-medium">
                Upload Agreement
              </div>
            </div>
          </AquiloButton>
        </div>
      ) : (
        <Button
          variant="contained"
          onClick={() => uploadEl.current?.click()}
          startIcon={<CloudUpload />}
          disabled={disabled}
        >
          Upload agreement
        </Button>
      )}
    </>
  );
};
